const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGaugeChartColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "66580e1b-facd-4971-bd44-deaa578f8c18"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      fill: "#f45e29",
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      opacity: 1
    },
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-436, -243.9)",
    d: "M 837.7 266.3 C 815.8000000000001 214.4 784.4000000000001 167.70000000000002 744.3000000000001 127.70000000000002 C 704.2 87.70000000000002 657.6 56.30000000000001 605.7 34.30000000000001 C 551.9 11.5 494.8 0 436 0 C 377.2 0 320.1 11.6 266.3 34.3 C 214.4 56.199999999999996 167.70000000000002 87.69999999999999 127.70000000000002 127.7 C 87.70000000000002 167.8 56.30000000000001 214.4 34.30000000000001 266.3 C 11.5 320.1 0 377.2 0 436 C 0 444.3 6.7 451 15 451 L 156 451 C 164.3 451 171 444.3 171 436 C 171 289.9 289.9 171 436 171 C 503.6 171 565.4 196.5 612.3 238.4 L 460.4 390.3 C 453 386.3 444.59999999999997 384.2 436 384.2 C 407.4 384.2 384.2 407.5 384.2 436 C 384.2 464.6 407.5 487.8 436 487.8 C 464.5 487.8 487.8 464.5 487.8 435.90000000000003 C 487.8 427.20000000000005 485.7 418.8 481.7 411.40000000000003 L 633.5 259.6 C 675.5 306.5 701 368.3 701 436 C 701 444.3 707.7 451 716 451 L 856.9 451 C 865.1999999999999 451 871.9 444.3 872 436 C 872 377.2 860.4 320.1 837.7 266.3 z M 723 148.9 C 759.7 185.60000000000002 788.5 228.10000000000002 808.6 274.3 L 705 314.8 C 690.5 282.7 670.2 253.10000000000002 644.6 227.4 C 613.9 196.70000000000002 577.7 173.7 538.2 159.10000000000002 L 571.3 53 C 627.7 72.9 679.4 105.3 723 148.9 z M 227.4 227.4 C 175.3 279.6 145 347.8 141.4 421 L 30.3 421 C 38.2 204 217.2 30 436 30 C 472.5 30 508.4 34.8 542.7 44.1 L 509.6 150.2 C 485.90000000000003 144.1 461.20000000000005 141 436 141 C 357.2 141 283.1 171.7 227.4 227.4 z M 436 457.8 C 424 457.8 414.2 448 414.2 436 C 414.2 424 424 414.2 436 414.2 C 441.8 414.2 447.3 416.5 451.4 420.59999999999997 C 455.5 424.7 457.79999999999995 430.2 457.79999999999995 435.99999999999994 C 457.8 448 448 457.8 436 457.8 z M 730.6 421 C 729.2 394 724.3000000000001 367.7 715.9 342.7 L 819.5 302.3 C 832.7 340.1 840.2 380 841.7 421 L 730.6 421 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(13.2 0 0 13.17 541 541)",
    id: "1f6347e2-5fd1-4fbb-a7cf-f314939238ff"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dedede"
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-50, -50)",
    d: "M 90.375 90.375 L 9.625 90.375 L 9.625 9.625 L 90.375 9.625 L 90.375 90.375 z M 11.625 88.375 L 88.375 88.375 L 88.375 11.625 L 11.625 11.625 L 11.625 88.375 z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaugeChartColored);
export default __webpack_public_path__ + "static/media/gauge-chart-colored.90e9427a.svg";
export { ForwardRef as ReactComponent };